import { isBrowser } from '@sbt-web/utils';
import { useState, useEffect } from 'react';

const isValidSHA256 = (hash) => /[A-Fa-f0-9]{64}/.test(hash);
const isValidString = (str) => typeof str === 'string' && str.length > 0;
class PublicUser {
    #id;
    #name;
    #email;
    constructor(id, name, email) {
        this.#id = id;
        this.#name = name;
        this.#email = email;
    }
    get id() {
        return this.#id;
    }
    get name() {
        return this.#name;
    }
    get email() {
        return this.#email;
    }
}
/**
 * Reads a named cookie from the browser.
 * @param name The cookie to retrieve
 * @returns The raw cookie value, or undefined if in Node.js or the cookie does not exist.
 */
const getCookie = (name) => {
    // document.cookie is not available on the server
    if (!isBrowser()) {
        return undefined;
    }
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts == undefined || parts.length != 2) {
        return '';
    }
    return parts.pop()?.split(';').shift();
};
const userInfoCookieName = 'user_data';
const getPublicUser = () => {
    try {
        const userDataJSON = getCookie(userInfoCookieName);
        if (userDataJSON === undefined || userDataJSON === '') {
            return null;
        }
        const rawUserData = JSON.parse(userDataJSON);
        if (!isValidString(rawUserData.id)) {
            throw new Error('Missing or invalid user id');
        }
        if (!isValidString(rawUserData.name)) {
            throw new Error('Missing or invalid user name');
        }
        if (!isValidSHA256(rawUserData.email)) {
            throw new Error('Missing or invalid user email hash');
        }
        return new PublicUser(rawUserData.id, decodeURIComponent(rawUserData.name ?? ''), rawUserData.email);
    }
    catch (e) {
        console.warn('Unable to parse user data from cookie:', e);
        return null;
    }
};
function usePublicUser() {
    const [user, setUser] = useState(null);
    useEffect(() => {
        setUser(getPublicUser());
    }, []);
    return user;
}

export { PublicUser, getCookie, getPublicUser, usePublicUser };
//# sourceMappingURL=PublicUserProvider.js.map
